export default __webpack_public_path__ + "static/media/review_industry.531f3140.svg";